import { IResponseAccountPayablesAdditionalInfo } from "Dashboard/scenes/Partners/domain/payables/IResponseAccountPayablesAdditionalInfo";
import { partnersService } from "Dashboard/scenes/Partners/services/partner.service";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormatDateShort } from "utils/dateUtils";
import { FormatNumberOrNull, FormatNumberWithUnitOrNull } from "utils/numberUtils";
import classesPartners from "../../../styles/popovers.module.scss";
import { selectPartner } from "../../Main/main.slice";


export const PayablesAdditionalInfoPopover = () => {
  const [payablesAdditionalInfo, setPayablesAdditionalInfo]
    = useState<IResponseAccountPayablesAdditionalInfo | undefined>(undefined);
  const partner = useSelector(selectPartner);

  useEffect(() => {
    const fetchData = async () => {
      if (partner) {
        const response = await partnersService.getPayablesAdditionalInfo(partner.partnerId);
        setPayablesAdditionalInfo(response);
      }
    };
    fetchData();
  }, [partner, partner?.partnerId]);

  return (
    <div className={classesPartners.detailsAdditionalInfoPopover}>
      <div className={classesPartners.column}>
        <div className={classesPartners.headerContainer}>
          <h1>LAGER</h1>
        </div>
        <div className={classesPartners.itemsContainer}>
          {payablesAdditionalInfo && payablesAdditionalInfo.stock.items.map((item, index) => {
            return (
              <div className={classesPartners.item}>
                <div className={classesPartners.itemTitle}>{item.title}</div>
                <div className={classesPartners.itemButtons}>
                  <input type="checkbox" disabled={!item.isXxx} checked={item.isXxx} />
                </div>

                <div className={`${classesPartners.itemRow2Value} ${classesPartners.value} ${classesPartners.alignRight}`}>{item.billOfLandingId}</div>
                <div className={`${classesPartners.itemRow2Label} ${classesPartners.label}`}>br.otpremnice</div>
                <div className={`${classesPartners.itemRow2Value2} ${classesPartners.value}`}>{FormatDateShort(item.date)}</div>

                <div className={`${classesPartners.itemRow3Value} ${classesPartners.value} ${classesPartners.alignRight}`}>{FormatNumberOrNull(item.quantityAmount)}</div>
                <div className={`${classesPartners.itemRow3Label} ${classesPartners.label}`}>
                  <span className={classesPartners.importantLabel}>{item.quantityUnit.name}</span>&nbsp;nabavljeno
                </div>

                <div className={`${classesPartners.itemRow4Value} ${classesPartners.value} ${classesPartners.alignRight}`}>{FormatNumberWithUnitOrNull(item.totalPrice, 'rsd')}</div>
                <div className={`${classesPartners.itemRow4Label} ${classesPartners.label}`}>cena</div>

              </div>
            );
          })}
        </div>
      </div>
      <div className={classesPartners.column}>
        <div className={classesPartners.headerContainer}>
          <h1>POTROŠNI MATERIJALI</h1>
        </div>
        <div className={classesPartners.itemsContainer}>
          {payablesAdditionalInfo && payablesAdditionalInfo.consumables.items.map((item, index) => {
            return (
              <div className={classesPartners.item}>
                <div className={classesPartners.itemTitle}>{item.title}</div>
                <div className={classesPartners.itemButtons}>
                  <input type="checkbox" disabled={!item.isXxx} checked={item.isXxx} />
                </div>

                <div className={`${classesPartners.itemRow2Value} ${classesPartners.value} ${classesPartners.alignRight}`}>{item.billOfLandingId}</div>
                <div className={`${classesPartners.itemRow2Label} ${classesPartners.label}`}>br.otpremnice</div>
                <div className={`${classesPartners.itemRow2Value2} ${classesPartners.value}`}>{FormatDateShort(item.date)}</div>

                <div className={`${classesPartners.itemRow3Value} ${classesPartners.value} ${classesPartners.alignRight}`}>{FormatNumberOrNull(item.quantityAmount)}</div>
                <div className={`${classesPartners.itemRow3Label} ${classesPartners.label}`}>
                  <span className={classesPartners.importantLabel}>{item.quantityUnit.name}</span>&nbsp;izdato
                </div>

                <div className={`${classesPartners.itemRow4Value} ${classesPartners.value} ${classesPartners.alignRight}`}>{FormatNumberWithUnitOrNull(item.totalPrice, 'rsd')}</div>
                <div className={`${classesPartners.itemRow4Label} ${classesPartners.label}`}>cena</div>

              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
